import axios from '../requester';
import { API } from '../constants/api-urls';

export const getBranchesSnapshots = async params =>
  axios.post(`${API.BRANCHES_PATH_V2}/snapshots/search`, params);

export const callBranchesCount = async requests =>
  axios.post(`${API.BRANCHES_PATH_V2}/snapshots/search/count`, { requests });

export const updateExcludeBranchCycleTime = async ({ branchId, queryParams }) =>
  axios.patch(
    `${API.BRANCHES_PATH}/${branchId}/cycle-time-exclusion?${queryParams}`
  );
